import type { TodoResponse } from '@/api/types/todo'

const normalize = (s: string) => s.normalize('NFKC').toLowerCase()

const parseTerms = (query: string) => normalize(query).split(/\s+/).filter(Boolean)

const matchesAllTerms = (todo: TodoResponse, terms: string[]) => {
  const haystack = normalize([`#${todo.id}`, todo.title, todo.project ?? '', ...todo.tags].join('\n'))
  return terms.every((term) => haystack.includes(term))
}

/** タイトル・プロジェクト・タグ・#ID をスペース区切りの AND で検索する。サブタスクが一致した親も残す */
export const filterTodosByQuery = (
  todos: TodoResponse[],
  query: string,
  childrenMap: Map<number, TodoResponse[]>,
): TodoResponse[] => {
  const terms = parseTerms(query)
  if (terms.length === 0) return todos
  return todos.filter(
    (todo) =>
      matchesAllTerms(todo, terms) || (childrenMap.get(todo.id) ?? []).some((child) => matchesAllTerms(child, terms)),
  )
}
